import React, { Component } from "react";
import axios from "axios";

import domain from ".././../../../domain";
import { Link } from "react-router-dom";
import { Button } from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Col, Card, CardBody } from "mdbreact";
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}
class TraineeDetailsById extends Component {
  constructor() {
    super();
    this.state = {
      participants: [],
      status: "",
      course_name: "",
      course_id: "",
    };
  }

  componentDidMount() {
    this.getParticipants();
    this.getCourse();
  }
  editButtonFormatter = (row) => {
    return this.state.status === "Completed" ? (
      <Link className="btn blue disabled" to="#">
        EDIT
      </Link>
    ) : (
      <Link className="btn blue" to={`/edit-participant/${row}`}>
        EDIT
      </Link>
    );
  };
  deleteButtonFormatter = (row) => {
    return this.state.status === "Completed" ? (
      <Button name="delete" value={row} disabled>
        DELETE
      </Button>
    ) : (
      <Button name="delete" value={row} onClick={this.onDelete.bind(this)}>
        DELETE
      </Button>
    );
  };

  onDelete = (e) => {
    e.preventDefault();
    console.log(e.target.value);
    let r = window.confirm("Do you want to delete the Trainee Details");
    if (r) {
      axios
        .delete(`${domain.DBServer}/delete-participant/${e.target.value}`)
        .then((response) => {
          console.log(response.data);
          if (response.data === 1) {
            alert("Trainee details deleted Successfully");
            window.location.reload();
          }
        })
        .catch((err) => console.log(err));
    } else return true;
  };

  async getCourse() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${courseId}`);
    console.log(result.data[0]);
    this.setState({
      status: result.data[0].status,
      course_name: result.data[0].title,
      course_id: result.data[0].course_id,
    });
  }

  getParticipants() {
    let courseId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-trainees/${courseId}`)
      .then((response) => {
        console.log(response.data);
        this.setState({ participants: response.data }, () => {
          //console.log(this.state);
        });
      })
      .catch((err) => console.log(err));
  }

  render() {
    console.log(this.state);
    let coursetable;
    if (this.state.participants != null) {
      coursetable = (
        <BootstrapTable
          data={this.state.participants}
          exportCSV
          striped
          hover
          version="4"
          // selectRow={selectRowProp}
          pagination
          search
          // tableStyle={ { border: '#0000FF 2.5px solid' } }
          // containerStyle={ { border: '#FFBB73 2.5px solid' } }
          //  headerStyle={ { border: 'red 1px solid' } }
          //  bodyStyle={ { border: 'green 1px solid' } }
          keyField="trainee_id"
        >
          <TableHeaderColumn
            width="50px"
            dataFormat={indexN}
            dataAlign="right"
            export={false}
          >
            S. No
          </TableHeaderColumn>
          <TableHeaderColumn dataField="trainee_id" dataSort width="100px">
            Trianee ID
          </TableHeaderColumn>
          <TableHeaderColumn dataField="name" dataSort>
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="designation" dataSort>
            Designation
          </TableHeaderColumn>
          <TableHeaderColumn dataField="organization" dataSort>
            Organisation
          </TableHeaderColumn>
          <TableHeaderColumn dataField="address" dataSort>
            Address
          </TableHeaderColumn>
          <TableHeaderColumn dataField="city" dataSort>
            City
          </TableHeaderColumn>
          <TableHeaderColumn dataField="t_state" dataSort>
            State
          </TableHeaderColumn>
          <TableHeaderColumn dataField="gender" dataSort>
            Gender
          </TableHeaderColumn>
          <TableHeaderColumn dataField="mobile" dataSort>
            Mobile
          </TableHeaderColumn>
          <TableHeaderColumn dataField="email" dataSort>
            Email
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="trainee_id"
            dataFormat={this.editButtonFormatter}
            disabled
            export={false}
          >
            Edit
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="trainee_id"
            dataFormat={this.deleteButtonFormatter}
            disabled
            export={false}
          >
            Delete
          </TableHeaderColumn>

          {/*  */}
        </BootstrapTable>
      );
    }

    return (
      <div>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                {this.state.status === "Completed" ? (
                  <Link
                    className="btn blue disabled"
                    to="#"
                    style={{ textAlign: "right" }}
                  >
                    Add More Trainees
                  </Link>
                ) : (
                  <Link
                    className="btn blue"
                    to={`/add-trainee/${this.state.course_id}`}
                    style={{ textAlign: "right" }}
                  >
                    Add More Trainees
                  </Link>
                )}
                {/* <Link className="btn grey" to="/Home">Back</Link> */}
                <h1 style={{ textAlign: "center", color: "blue" }}>
                  Participant Details of {this.state.course_name}{" "}
                </h1>
                {coursetable}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default TraineeDetailsById;
